<ecp-hero title="Bulk Order Upload" image="assets/images/headers/experts.jpg"> </ecp-hero>

<div class="container">
  <div class="col s12 is-flex is-fullwidth">
    <div class="mt-50">
      <ng-container *ngIf="!isPreview; else showPreview">
        <ecp-order-upload (orderUploadData)="previewOrders($event)"></ecp-order-upload>
      </ng-container>
      <ng-template #showPreview>
        <ecp-order-validation [orderDetails]="orderDetails"></ecp-order-validation>
        <ecp-order-upload-preview [orderDetails]="orderDetails"></ecp-order-upload-preview>
        <ng-container *ngIf="!isUploaded; else viewOrder">
          <div class="row mt-20">
            <div class="col m8 offset-m4">
              <div class="btn-group">
                <button type="button" class="btn btn-outline" (click)="downloadOrders()">
                  Download Report
                </button>
                <button type="button" class="btn btn-outline" (click)="cancelUpload()">
                  Cancel & Re-Upload
                </button>
                <button
                  type="button"
                  class="btn btn-primary"
                  (click)="uploadOrders()"
                  [disabled]="orderDetails?.uploadHasError"
                >
                  Submit Orders
                </button>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-template #viewOrder>
          <div class="row mt-20">
            <div class="col m4 offset-m8">
              <div class="btn-group">
                <button type="button" class="btn btn-primary" routerLink="/bulk-orders">
                  View Orders
                </button>
              </div>
            </div>
          </div>
        </ng-template>
      </ng-template>
    </div>
  </div>
</div>
